export class Code {
  public ID: string;
  public Name: string;
}



// WEBPACK FOOTER //
// ./src/app/models/Code.ts